<template>
   <div class="banner banner--desktop-middle-center" style="min-height: 500px">
        <div class="banner__content" style="align-items: center!important;">
            <div class="banner__layout center-align">
                <h1 class="title-xl text-rothcoBlack">{{ status }}</h1>
                <p class="paragraph-default text-rothcoBlack">There was an error with your request</p>
            </div>
        </div>
    </div>
  </template>
  <script lang="ts" setup>
    let props = defineProps({
        status: {
            type: Number,
            default: 404
        }
    })
  </script>